import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  inject,
  Input,
  Output,
} from '@angular/core';

@Directive({
  selector: '[auxClickOutside]',
  standalone: true,
})
export class ClickOutsideDirective {
  private elementRef = inject(ElementRef);

  @Output() auxClickOutside = new EventEmitter<HTMLElement>();
  @Input() skipInitial = true;

  @HostListener('document:click', ['$event.target'])
  public onClick(target: HTMLElement) {
    const clickedInside = this.elementRef.nativeElement.contains(target);

    if (!clickedInside) {
      if (!this.skipInitial) {
        this.auxClickOutside.emit(target);
      }

      this.skipInitial = false;
    }
  }
}
